import { gql } from '@apollo/client';

export const getAssignedLinesList = gql`
  query getAssignedLinesList($selectedBusinessUserID: String!) {
    SalesforceManagement {
      queries {
        getDistinctAssignedBPLineListWithoutPagination(
          selectedBusinessUserID: $selectedBusinessUserID
        ) {
          salesforceManagement_AssignedBPPlan_LineID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Id
                  Name
                  ExternalCode
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const updateBusinessUserAuthorities = gql`
  mutation updateBusinessUserAuthorities(
    $entityId: String!
    $allowPlanCoverEdits: Boolean!
    $allowPolicyEndDateEdits: Boolean!
    $allowClauseEdits: Boolean!
    $allowGroupPolicy: Boolean!
    $allowEndorsement: Boolean
    $allowEndorsementCostEdits: Boolean
    $allowPolicyCorrection: Boolean!
    $editableLineChargesIDs: [String!]!
  ) {
    salesforceManagement {
      entities {
        businessUser {
          salesforceManagement {
            updateBusinessUserAuthorities(
              entityId: $entityId
              allowPlanCoverEdits: $allowPlanCoverEdits
              allowPolicyEndDateEdits: $allowPolicyEndDateEdits
              allowClauseEdits: $allowClauseEdits
              editableLineChargesIDs: $editableLineChargesIDs
              allowGroupPolicy: $allowGroupPolicy
              allowEndorsement: $allowEndorsement
              allowEndorsementCostEdits: $allowEndorsementCostEdits
              allowPolicyCorrection: $allowPolicyCorrection
            ) {
              id
            }
          }
        }
      }
    }
  }
`;
